import React from "react";
import { Link } from "react-router-dom";
import { PROFILE, NAV } from "../data/content";
import { DynamicLogo } from "./DynamicLogo";
import { Mail, MapPin, Linkedin } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="border-t hairline mt-24" data-testid="site-footer" style={{ background: "var(--surface)" }}>
      <div className="mx-auto max-w-[1600px] px-6 sm:px-10 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <DynamicLogo size="md" />
          <p className="mt-6 text-sm max-w-xs" style={{ color: "var(--muted-t)" }}>
            Bridging human behavior with business metrics to scale digital products across APAC.
          </p>
        </div>

        <div>
          <p className="eyebrow mb-5">Navigate</p>
          <ul className="space-y-3">
            <li><Link to="/" className="text-sm hover:opacity-70 transition-opacity" style={{ color: "var(--text)" }}>Home</Link></li>
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-sm hover:opacity-70 transition-opacity" style={{ color: "var(--text)" }}>{n.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="eyebrow mb-5">Get in touch</p>
          <ul className="space-y-3 text-sm" style={{ color: "var(--muted-t)" }}>
            <li className="flex items-center gap-3"><Mail size={15} style={{ color: "var(--accent)" }} /><a href={`mailto:${PROFILE.email}`} className="hover:opacity-70 transition-opacity">{PROFILE.email}</a></li>
            <li className="flex items-center gap-3"><MapPin size={15} style={{ color: "var(--accent)" }} />{PROFILE.location}</li>
            <li className="flex items-center gap-3"><Linkedin size={15} style={{ color: "var(--accent)" }} /><a href={PROFILE.linkedin} target="_blank" rel="noreferrer" className="hover:opacity-70 transition-opacity">linkedin.com/in/yuvap</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t hairline">
        <div className="mx-auto max-w-[1600px] px-6 sm:px-10 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs" style={{ color: "var(--muted-t)" }}>
          <span>© {new Date().getFullYear()} {PROFILE.name}. All rights reserved.</span>
          <span>Director of User Experience — Chennai, India</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
